// handlebars-paginate
// https://github.com/olalonde/handlebars-paginate/blob/master/index.js
// ---
// generated by coffee-script 1.9.2
module.exports = function(pagination, options) {
  var i,
    leftCount,
    limit,
    newContext,
    page,
    pageCount,
    ret,
    rightCount,
    start,
    type;
  type = options.hash.type || "middle";
  ret = "";
  pageCount = Number(pagination.pageCount);
  page = Number(pagination.page);
  limit = void 0;

  if (options.hash.limit) {
    limit = +options.hash.limit;
  }
  newContext = {};

  switch (type) {
    case "middle":
      if (typeof limit === "number") {
        i = 0;
        leftCount = Math.ceil(limit / 2) - 1;
        rightCount = limit - leftCount - 1;
        if (page + rightCount > pageCount) {
          leftCount = limit - (pageCount - page) - 1;
        }
        if (page - leftCount < 1) {
          leftCount = page - 1;
        }
        start = page - leftCount;
        while (i < limit && i < pageCount) {
          newContext = {
            n: start
          };
          if (start === page) {
            newContext.active = true;
          }
          ret = ret + options.fn(newContext);
          start++;
          i++;
        }
      } else {
        i = 1;
        while (i <= pageCount) {
          newContext = {
            n: i
          };
          if (i === page) {
            newContext.active = true;
          }
          ret = ret + options.fn(newContext);
          i++;
        }
      }
      break;

    case "previous":
      if (page === 1) {
        newContext = {
          disabled: true,
          n: 1
        };
      } else {
        newContext = {
          n: page - 1
        };
      }
      ret = ret + options.fn(newContext);
      break;

    case "next":
      newContext = {};
      if (page === pageCount) {
        newContext = {
          disabled: true,
          n: pageCount
        };
      } else {
        newContext = {
          n: page + 1
        };
      }
      ret = ret + options.fn(newContext);
  }
  return ret;
};
